import React, {useEffect, useState} from "react";
import Accordion from 'react-bootstrap/Accordion';
import './pillar-card.scss';
import {MdKeyboardArrowDown} from "react-icons/md";
import {BiCheckDouble} from "react-icons/bi";
import {Checkbox, Modal, Spin} from 'antd';
import {Controller, useForm} from "react-hook-form";
import {PillarsService} from "../../../../services/pillars-api.service";
import ThemeButton from "../../../common/theme-button/ThemeButton";
import {CheckboxEmpty, CheckboxFill} from "../../../../../assets/icons/defaultIcons";
import DescriptionField from "../../../common/description-field/DescriptionField";
import {useUser} from "../../../../providers/UserContext";
import {checkEmptySpaces} from "../../../../utils/patterns";
import {LoadingOutlined} from '@ant-design/icons';
import {useNavigate} from "react-router-dom";
import PillarCheckboxComponent from "./PillarCheckboxComponent";

export default function PillarCard8({ heading, icon, options, hasInputText, setPillarLoader, GetPillarsData, selectedItem }) {
    const [loader, setLoader] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState({});
    const [updateCheckLength, setUpdateCheckLength] = useState(false);
    const { pointUpdate, setPointUpdate } = useUser();
    const navigate = useNavigate();

    const [antDesignOptions, setAntDesignOptions] = useState(options.map(question => ({
        label: question.name,
        value: question.mainQuestionId,
        name: question.name,
        status: question.status,
        mainQuestionId: question.mainQuestionId,
        questions: question.questions,
        content: question?.content ? question?.content : []
    })));



    console.log(options , 'pillars options')

    const [totalOptions, setTotalOptions] = useState(antDesignOptions.length);
    const [checkedList, setCheckedList] = useState([]);
    const [allChecked, setAllChecked] = useState(false);
    const [activeKey, setActiveKey] = useState("0");
    const [checkedItems, setCheckedItems] = useState([]);


    const handleSelect = () => {
        setActiveKey("0");
    };

    useEffect(() => {
        setTotalOptions(antDesignOptions.length);
        updateCheckedStates();
    }, [antDesignOptions]);

    const updateCheckedStates = () => {
        const checked = antDesignOptions.filter(opt => opt.status).map(opt => opt.value);
        setCheckedList(checked);
    };

    const handleAntOptions = (item, status) => {
        const updatedOptions = antDesignOptions.map(opt => {
            if (opt.value === item.value) {
                return { ...opt, status };
            }
            return opt;
        });

        setAntDesignOptions(updatedOptions);
        updateChecksStatus(item.value, status);
        setPointUpdate(!pointUpdate);
    };

    const updateChecksStatus = (value, status) => {
        setCheckedList(prevCheckedList => {
            if (status) {
                return [...prevCheckedList, value];
            } else {
                return prevCheckedList.filter(val => val !== value);
            }
        });
    };

    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch
    } = useForm({
        mode: 'onChange',
    });

    const openQuestionModal = (item, name) => {
        console.log( item, 'name of pillar')
        setModalContent(item);
        setValue('text', item.status && item.content.length > 0 ? item.content[0].text : '');
        setIsModalVisible(true);
    };

    const updateStatusToTrue = (mainQuestionId, text) => {
        setAntDesignOptions(currentOptions =>
            currentOptions.map(opt => {
                if (opt.mainQuestionId === mainQuestionId) {
                    return { ...opt, status: true, content: [{ ...opt.content[0], text }] };
                }
                return opt;
            })
        );
    };

    const onSubmit = async (data) => {
        setLoader(true);
        let payload = {
            status: true,
            content: [{ label: modalContent.label, text: data.text }]
        };
        const response = await PillarsService.updateCurrentDatePillars(modalContent.mainQuestionId, payload);
        if (response?.data?.data?.status) {
            updateStatusToTrue(modalContent.mainQuestionId, data.text);
            setPointUpdate(!pointUpdate);
            setIsModalVisible(false);
        }
        setLoader(false);
        reset();
    };

    const transformLabelWithLineBreaks = (label) => {
        return label.replace(/\\n/g, '\n').split('\n').map((part, index, array) => (
            <React.Fragment key={index}>
                {part}
                {index < array.length - 1 && <br />}
            </React.Fragment>
        ));
    };



// Update `checkedItems` when modalContent changes (Reset Checkboxes on Modal Open)
    useEffect(() => {
        if (modalContent?.questions?.length > 0) {
            // If modalContent.status is true, set all checkboxes to checked by default
            const defaultChecked = modalContent.status
                ? new Array(modalContent.questions.length).fill(true) // ✅ All checked
                : new Array(modalContent.questions.length).fill(false); // ❌ All unchecked

            setCheckedItems(defaultChecked);
        }
    }, [modalContent]);

// Handle checkbox changes
    const handleCheckboxChange = (index) => {
        let updatedChecked = [...checkedItems];
        updatedChecked[index] = !updatedChecked[index]; // Toggle checkbox state
        setCheckedItems(updatedChecked);
    };

// ✅ Ensure submit button is disabled when `modalContent.status === true`
// ✅ Otherwise, the button is disabled until all checkboxes are checked
    const isSubmitDisabled = modalContent.status || !checkedItems.every(item => item);

    async function openNormalModal(item) {
        console.log(item, 'pillar items')

        // setPillarLoader(true)
        setLoader(true)
        const response = await PillarsService.updateCurrentDatePillars(item.value, { status: true});

        if (response?.data?.data?.status) {
            setIsModalVisible(false);
            let updatedItem = handleAntOptions(item, !item.status)
            // setPillarItem(updatedItem);
            setLoader(false)
            // setUpdateCheckLength(!updateCheckLength)
        }
    }

    return (
        <div className={'pillar-card'}>
            <Accordion activeKey={activeKey} onSelect={handleSelect}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <div className={`pillar-header ${checkedList.length === totalOptions ? 'all-checked' : ''}`}>
                            <div>
                                <h4><span className={'icon-circle'}><img height={35} width={35} src={icon} /></span> {heading}</h4>
                            </div>
                            <div className={'options'}>
                                <span className={`counter ${checkedList.length === totalOptions ? 'all-checked' : ''}`}>
                                    {checkedList.length === totalOptions && <BiCheckDouble />}
                                    {checkedList.length} <i>/ {totalOptions}</i>
                                </span>
                                <div className={'icon'}>
                                    <MdKeyboardArrowDown />
                                </div>
                            </div>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        {
                            !hasInputText ?
                                <div className={`checkkbox-div ${loader ? 'disabled ' : ''}`}>
                                    {
                                        antDesignOptions.map((item, index) => (
                                            <PillarCheckboxComponent
                                                key={index}
                                                item={item}
                                                index={index}
                                                setUpdateCheckLength={setUpdateCheckLength}
                                                updateCheckLength={updateCheckLength}
                                                handleAntOptions={handleAntOptions}
                                            />
                                        ))
                                    }
                                </div>
                                :
                                <div className={`checkkbox-div ${loader ? 'disabled ' : ''}`}>
                                    {
                                        antDesignOptions.map((item, index) => {
                                            console.log("Mapped Item:", item.name); // Logging each item

                                            return (
                                                <div
                                                    className={`checkbox-box ${item.status && 'checked'}`}
                                                    key={index}
                                                    onClick={!loader ? () => openQuestionModal(item, item.name) : undefined}
                                                >
                                                    {
                                                        loader ? <Spin className={'check-spinner'} indicator={<LoadingOutlined spin />} /> :
                                                            <span> {item.status ? <CheckboxFill /> : <CheckboxEmpty />} </span>
                                                    }
                                                    <span className={''}>{item.label}</span>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                        }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Modal
                title={modalContent.label}
                visible={isModalVisible}
                centered
                footer={false}
                wrapClassName='theme-modals pillar-modal'
                onCancel={() => {
                    setIsModalVisible(false);
                    reset();
                }}
                width={550}
                maskClosable={false}
            >
                {/* Show Form if name === "Learn" */}
                {modalContent.name === "Learn" ? (
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='dfields'>
                            <Controller
                                name='text'
                                control={control}
                                defaultValue=''
                                rules={{ required: true, maxLength: 1000, validate: checkEmptySpaces }}
                                render={({ field }) => (
                                    <DescriptionField
                                        placeholder='Write your text here'
                                        type='text'
                                        label={transformLabelWithLineBreaks(modalContent.questions[0])}
                                        field={field}
                                        errors={errors.text}
                                        autoSize={{ minRows: 12, maxRows: 12 }}
                                    />
                                )}
                            />
                        </div>
                        <div className={'view-archive'}>
                            <p onClick={() => { navigate('/pillar/archives') }}>View Archives</p>
                        </div>
                        <div className='mt-30'>
                            <ThemeButton
                                text='Submit'
                                type='submit'
                                className='btn-light-lg'
                                loader={loader}
                            />
                        </div>
                    </form>
                ) : (
                    // Show Checkboxes for other cases
                    <>
                        {/* Checkboxes Section */}
                        <div className={'checkbox checkkbox-div plan-checkbox'}>
                            {modalContent?.questions?.map((question, index) => (
                                <Checkbox
                                    key={index}
                                    onChange={() => handleCheckboxChange(index)}
                                    checked={checkedItems[index]}
                                >
                                    {question}
                                </Checkbox>
                            ))}
                        </div>

                        {/* Submit Button with Validation */}
                        <div className='mt-30'>
                            <ThemeButton
                                text='Submit'
                                type='submit'
                                className='btn-light-lg'
                                loader={loader}
                                onClick={() => { openNormalModal(modalContent) }}
                                disabled={isSubmitDisabled} // Button disabled if `modalContent.status === true` or checkboxes not checked
                            />
                        </div>
                    </>
                )}
            </Modal>
        </div>
    );
}